import React from 'react';
import { Shield, Lock } from 'lucide-react';

const PrivacyBadge = ({ message, icon = 'shield', compact = false }) => {
  const Icon = icon === 'lock' ? Lock : Shield;

  if (compact) {
    return (
      <div className="inline-flex items-center gap-2 px-3 py-1 bg-indigo-50 border border-indigo-200 rounded-full text-xs text-indigo-800">
        <Icon className="h-3 w-3" />
        <span>{message}</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 p-4 bg-indigo-50 border-2 border-indigo-200 rounded-lg">
      <Icon className="h-5 w-5 text-indigo-600 flex-shrink-0" />
      <p className="text-sm text-indigo-900 font-medium">{message}</p>
    </div>
  );
};

export default PrivacyBadge;
